import _ from 'lodash'
import { toRoman } from 'roman-numerals'

export class RepublicanDate
{
    static MONTHS = [
        'vendemiaire',
        'brumaire',
        'frimaire',
        'nivose',
        'pluviose',
        'ventose',
        'germinal',
        'floreal',
        'prairial',
        'messidor',
        'thermidor',
        'fructidor',
        'complementaire'
    ]

    static INTERCALARY_DAY = 6
    static COMPLEMENTARY_MONTH = 13
    static LEAP_YEARS = [3, 7, 11]
    static MAX_YEARS = 14
    static MAX_DAYS = 30

    constructor(year, month, decade, dayInDecade)
    {
        this.year = year
        this.month = month
        this.decade = decade
        this.dayInDecade = dayInDecade

        this.validateFields()
    }

    validateFields()
    {
        if(! _.inRange(this.year, 1, RepublicanDate.MAX_YEARS + 1))
        {
            throw new Error(`Year is invalid: expected date between 1 (I) and 14 (XIV), given ${this.year}`)
        }

        if(! _.inRange(this.month, 1, RepublicanDate.MONTHS.length + 1))
        {
            throw new Error(`Month is invalid: expected month between 1 and 13, given ${this.month}`)
        }

        if(! _.inRange(this.decade, 1, 4))
        {
            throw new Error(`Decade is invalid: expected decade between 1 and 3, given ${this.decade}`)
        }

        if(! _.inRange(this.dayInDecade, 1, 11))
        {
            throw new Error(`Day in decade is invalid : expected day between 1 and 10, given ${this.dayInDecade}`)
        }
    }

    static fromPrimitives(year, month, day)
    {
        const decade = RepublicanDate.decadeFromDay(day)
        const dayInDecade = RepublicanDate.dayInDecadeFromDay(day)

        return new RepublicanDate(year, month, decade, dayInDecade)
    }

    day()
    {
        return this.dayFromDecade(this.dayInDecade, this.decade)
    }

    monthAsString()
    {
        return RepublicanDate.MONTHS[this.month - 1]
    }

    yearAsString()
    {
        return toRoman(this.year)
    }

    dayFromDecade(dayInDecade, decade)
    {
        return dayInDecade + (10 * (decade - 1))
    }

    static dayInDecadeFromDay(day)
    {
        const decade =  RepublicanDate.decadeFromDay(day)

        return day - (10 * (decade - 1))
    }

    static decadeFromDay(day)
    {
        return  Math.floor((day - 1) / 10) + 1
    }

    static monthsAvailable(day)
    {
        return _.filter(RepublicanDate.MONTHS, (month, index) =>
            ! (
                day > RepublicanDate.INTERCALARY_DAY
                && (index + 1) === RepublicanDate.COMPLEMENTARY_MONTH
            )
        )
    }

    static yearsAvailable(day, month)
    {
        if(
            day === RepublicanDate.INTERCALARY_DAY
            && month === RepublicanDate.COMPLEMENTARY_MONTH
        )
        {
            return RepublicanDate.LEAP_YEARS
        }

        return _.range(1, RepublicanDate.MONTHS.length + 1);
    }
}
